// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import Pagination from "@material-ui/lab/Pagination";
// core componentssrc
import componentStylesGeneric from "assets/theme/views/admin/generic";
import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import TableStateChip from "components/Cards/Tables/TableStateChip";
import { ConditionGuard } from "guards/ConditionGuard";
import { useFormContext } from "react-hook-form";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom";
import { CONTRACT_APPROVAL_STATUS, TABLE_STATE_CHIP_COLOR } from "utils/const";

const useStylesGeneric = makeStyles(componentStylesGeneric);
const useStylesLocal = makeStyles(() => ({
  workersNamesColumn: {
    width: "40ch",
    maxWidth: "40ch",
    minWidth: "40ch",
  },
  workersNamesText: {
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const ResultSection = (props) => {
  const theme = useTheme();
  const classes = useStylesGeneric();
  const localClasses = useStylesLocal();
  const location = useLocation();

  const { watch, setValue } = useFormContext();
  const { data, isLoading } = props;

  const page = watch("pageIndex");

  const formatWorkersNames = (workersNames) => {
    if (!workersNames) {
      return "";
    }
    return workersNames.length > 40 ? `${workersNames.slice(0, 40)}...` : workersNames;
  };

  const tableHead = [
    { label: "Data de Submissão", sortKey: "requestDate" },
    { label: "Nº de Pedido", sortKey: "requestNumber" },
    { label: "Nº de contratos", sortKey: "numberOfContracts" },
    { label: "Tipo de Contrato", sortKey: "contractType" },
    { label: "Ramo de Actividade", sortKey: "companyActivityDescription" },
    { label: "Nome(s) do(s) Trabalhador(es)", sortKey: "workersNames" },
    { label: "Estado", sortKey: "statusDescription" },
  ];

  const handleSort = (columnIndex) => {
    const column = tableHead[columnIndex].sortKey;

    let nextSortColumn = column;
    let nextSortDirection = "asc";

    if (props.sortColumn === column) {
      nextSortDirection = props.sortDirection === "asc" ? "desc" : "asc";
      props.setSortDirection(nextSortDirection);
    } else {
      props.setSortColumn(nextSortColumn);
      props.setSortDirection(nextSortDirection);
    }

    setValue("pageIndex", 1);

    if (props.onSortChange) {
      props.onSortChange(nextSortColumn, nextSortDirection);
    }
  };

  const renderSortIcon = (columnIndex) => {
    const column = tableHead[columnIndex].sortKey;
    if (props.sortColumn === column) {
      return props.sortDirection === "desc" ? (
        <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle" }} />
      ) : (
        <ArrowDownwardIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle" }} />
      );
    }
    return <UnfoldMoreIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: "middle", opacity: 0.3 }} />;
  };

  const mapOpportunityStateToTableChipColors = (stateKey) => {
    switch (stateKey) {
      case CONTRACT_APPROVAL_STATUS.CONCLUDED:
        return TABLE_STATE_CHIP_COLOR.GREEN;
      case CONTRACT_APPROVAL_STATUS.CANCELED:
        return TABLE_STATE_CHIP_COLOR.RED;
      case CONTRACT_APPROVAL_STATUS.AWAITING_PAYMENT:
      case CONTRACT_APPROVAL_STATUS.AWAITING_RECTIFICATION:
      case CONTRACT_APPROVAL_STATUS.AWAITING_VALIDATION:
      case CONTRACT_APPROVAL_STATUS.AWAITING_PAYMENT_DATA:
        return TABLE_STATE_CHIP_COLOR.LIGHT_ORANGE;
      case CONTRACT_APPROVAL_STATUS.CREATED:
        return TABLE_STATE_CHIP_COLOR.YELLOW;
      case CONTRACT_APPROVAL_STATUS.SUBMITTED:
        return TABLE_STATE_CHIP_COLOR.BLUE;
      default:
        return <></>;
    }
  };

  return (
    <>
      <CardTableContainer title={"Lista de pedidos de homologação de contratos de trabalho"} count={data?.totalCount}>
        <TableContainer>
          <ConditionGuard condition={!isLoading} fallback={<TableBackdrop open />}>
            <Box component={Table} alignItems="center" marginBottom="0!important">
              <TableHead>
                <TableRow>
                  {tableHead.map((prop, key) => (
                    <TableCell
                      key={key}
                      classes={{
                        root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                      }}
                      onClick={() => handleSort(key)}
                      style={{ cursor: "pointer", userSelect: "none" }}
                      className={prop.sortKey === "workersNames" ? localClasses.workersNamesColumn : undefined}
                    >
                      <Box display="flex" alignItems="center">
                        {prop.label}
                        {renderSortIcon(key)}
                      </Box>
                    </TableCell>
                  ))}
                  <TableCell
                    key="detailsCol"
                    classes={{
                      root:
                        classes.tableCellRoot +
                        " " +
                        classes.tableCellRootHead +
                        " " +
                        classes.tableCellHeadStickyRight,
                    }}
                  >
                    Detalhes
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.data?.map((prop, key) => (
                  <TableRow key={key}>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.requestDate}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.requestNumber}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.numberOfContracts}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.contractTypeDescriptions}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.companyActivityDescription}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }} className={localClasses.workersNamesColumn}>
                      <Box className={localClasses.workersNamesText} title={prop.workersNames}>
                        {formatWorkersNames(prop.workersNames)}
                      </Box>
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      <TableStateChip
                        state={mapOpportunityStateToTableChipColors(prop.statusKeyValue)}
                        message={prop.statusDescription}
                      />
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellBodyStickyRight }}>
                      <Tooltip title={"Detalhes"}>
                        <Link
                          to={{
                            pathname: `/admin/contract-approval/details/${prop.requestNumber}`,
                            state: { from: `${location.pathname}${location.search || ""}` },
                          }}
                        >
                          <IconButton>
                            <Box
                              component={ArrowForwardIosIcon}
                              width="12px!important"
                              height="12px!important"
                              color={theme.palette.primary.main}
                            />
                          </IconButton>
                        </Link>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Box>
          </ConditionGuard>
        </TableContainer>

        <Box classes={{ root: classes.cardActionsRoot }} component={CardActions} justifyContent="flex-end"></Box>

        <Pagination
          className={classes.alignPagination}
          count={data?.totalPages}
          page={page}
          onChange={(_, value) => {
            setValue("pageIndex", value);

            if (props.onPageChange) {
              props.onPageChange(value);
            }
          }}
          color="primary"
        ></Pagination>
      </CardTableContainer>

      {!isLoading && data?.data?.length === 0 && (
        <Box classes={{ root: classes.noResultsInfo }}>Não foram encontrados resultados para esta pesquisa.</Box>
      )}
    </>
  );
};

export default ResultSection;
